import React, { useState, useEffect } from "react";
import Content from "../components/Content";
import Layout from "../containers/LayoutAdministrativo";
import SaveIcon from "@mui/icons-material/Save";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import MailIcon from "@mui/icons-material/Mail";
import CachedIcon from "@mui/icons-material/Cached";
import DoctoresService from "../services/DoctoresService";
import SolicitudesService from "../services/SolicitudesService";
import SolicitudesEstudiosService from "../services/SolicitudesEstudiosService";
import InfoIcon from "@mui/icons-material/Info";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/EditSquare";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import DescriptionIcon from "@mui/icons-material/Description";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import AssignmentIcon from "@mui/icons-material/Assignment";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EstudiosService from "../services/EstudiosService";
import AreasService from "../services/AreasService";
import ParametrosEstudioService from "../services/ParametrosEstudioService";
import EstudiosIntService from "../services/EstudiosIntService";
import HistorialEstudiosService from "../services/HistorialEstudiosService";
import { mostrarModalHistorialEstudio, mostrarModalHistorialImpresionEnvio } from "../utils/HistorialSwal";

import { useNavigate, useLocation } from "react-router-dom";
import {
  Grid,
  TextField,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Select,
  MenuItem,
  InputLabel,
  Paper,
  Typography,
  OutlinedInput,
  Stack,
  Box,
  IconButton,
  Button,
  Tooltip,
  tooltipClasses,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Tab,
  Tabs,
  Chip,
  CircularProgress,
  Collapse,
  Checkbox,
} from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import PrintIcon from "@mui/icons-material/Print";
import HistoryIcon from "@mui/icons-material/History";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { mostrarToast } from "../utils/toastUtils";
import { generarPDFResultados } from "../utils/pdfResultadosUtils";
import { ejecutarConCargandoPDF } from "../utils/pdfLoadingUtils";

const REPORTE_STATE_KEY = "reporte_resultados_view_state";

const saveReporteState = (stateObj) => {
  try {
    const existing = JSON.parse(sessionStorage.getItem(REPORTE_STATE_KEY) || "{}");
    sessionStorage.setItem(REPORTE_STATE_KEY, JSON.stringify({ ...existing, ...stateObj }));
  } catch (e) { }
};

const getReporteState = () => {
  try {
    const s = sessionStorage.getItem(REPORTE_STATE_KEY);
    return s ? JSON.parse(s) : null;
  } catch (e) {
    return null;
  }
};

const ModalExpedienteContent = ({
  paciente,
  solicitudesPaciente,
  formatNombrePaciente,
  formatEstadoSolicitud,
  getEstadoSolicitudChipStyles,
  formatFecha,
}) => {
  const [expanded, setExpanded] = useState({});
  const [estudiosMap, setEstudiosMap] = useState({});
  const [seleccionadosMap, setSeleccionadosMap] = useState({});

  useEffect(() => {
    solicitudesPaciente.forEach(async (sol) => {
      const idSol = sol.idSolicitud || sol.orden || sol.codigo;
      const key = String(sol.orden || idSol);
      if (!estudiosMap[key] && idSol) {
        try {
          const res = await SolicitudesEstudiosService.getEstudiosPorSolicitud(idSol);
          const estudiosList = Array.isArray(res) ? res : (res?.estudios || res?.data || []);
          const detalles = await Promise.all(
            estudiosList.map(async (est) => {
              try {
                const det = await EstudiosService.getEstudioPorId(est.idEstudio || est.id);
                return {
                  ...est,
                  codigo: det?.codigo || est.codigo || "",
                  nombre: det?.nombre || est.nombreEstudio || est.nombre || "",
                  estatus: est.estatus || est.estado
                };
              } catch (e) {
                return {
                  ...est,
                  codigo: est.codigo || "",
                  nombre: est.nombreEstudio || est.nombre || "",
                  estatus: est.estatus || est.estado
                };
              }
            })
          );
          setEstudiosMap((prev) => ({ ...prev, [key]: detalles }));
        } catch (err) {
          console.error("Error al cargar estudios de la solicitud:", err);
        }
      }
    });
  }, [solicitudesPaciente]);

  const toggleExpand = (key) => {
    setExpanded((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const handleToggleCheckEstudio = (key, estudio) => {
    setSeleccionadosMap((prev) => {
      const list = prev[key] || [];
      const idEst = estudio.idEstudio || estudio.id;
      const exists = list.some((e) => (e.idEstudio || e.id) === idEst);
      let updated;
      if (exists) {
        updated = list.filter((e) => (e.idEstudio || e.id) !== idEst);
      } else {
        updated = [...list, estudio];
      }
      return { ...prev, [key]: updated };
    });
  };

  const handleImprimirSeleccionados = async (solicitud, key) => {
    const seleccionados = seleccionadosMap[key] || [];
    if (seleccionados.length === 0) {
      Swal.fire("Atención", "Por favor seleccione al menos un estudio liberado para imprimir.", "warning");
      return;
    }
    await ejecutarConCargandoPDF(
      async () => {
        await generarPDFResultados(solicitud, seleccionados, false);
      },
      "Generando informe de resultados y parámetros...",
      "Procesando PDF"
    );
  };

  const handleImprimirTodos = async (solicitud, key) => {
    const estudios = estudiosMap[key] || [];
    await ejecutarConCargandoPDF(
      async () => {
        await generarPDFResultados(solicitud, estudios, false);
      },
      "Generando informe completo de la solicitud...",
      "Procesando PDF"
    );
  };

  return (
    <Box sx={{ width: "100%", maxHeight: "75vh", overflowY: "auto", p: 1, textTransform: "none" }}>
      <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2, color: "#18234f", textAlign: "left" }}>
        Expediente Clínico del Paciente: {paciente}
      </Typography>
      <Table size="small" sx={{ border: "1px solid #e0e0e0" }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#18234f" }}>
            <TableCell sx={{ color: "white", fontWeight: "bold", width: "50px" }}>Ver</TableCell>
            <TableCell sx={{ color: "white", fontWeight: "bold" }}>Sucursal</TableCell>
            <TableCell sx={{ color: "white", fontWeight: "bold" }}>Orden</TableCell>
            <TableCell sx={{ color: "white", fontWeight: "bold" }}>Nombre del Paciente</TableCell>
            <TableCell sx={{ color: "white", fontWeight: "bold" }}>Estado de la Orden</TableCell>
            <TableCell sx={{ color: "white", fontWeight: "bold" }}>Fecha de Entrega</TableCell>
            <TableCell align="center" sx={{ color: "white", fontWeight: "bold" }}>Imprimir Todos</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {solicitudesPaciente.map((sol, index) => {
            const key = String(sol.orden || sol.idSolicitud || sol.codigo);
            const isExp = !!expanded[key];
            const estudios = estudiosMap[key] || [];
            const todosLiberados = estudios.length > 0 && estudios.every((e) => String(e.estatus || e.estado).toUpperCase() === "L");
            const seleccionados = seleccionadosMap[key] || [];

            return (
              <React.Fragment key={index}>
                <TableRow sx={{ backgroundColor: index % 2 === 0 ? "#fafafa" : "#ffffff" }}>
                  <TableCell onClick={() => toggleExpand(key)} sx={{ cursor: "pointer" }}>
                    <IconButton size="small" sx={{ color: "#1976d2" }}>
                      {isExp ? <KeyboardArrowDownIcon /> : <ArrowForwardIosIcon sx={{ fontSize: "1rem" }} />}
                    </IconButton>
                  </TableCell>
                  <TableCell onClick={() => toggleExpand(key)} sx={{ cursor: "pointer" }}>{sol.sucursal || "-"}</TableCell>
                  <TableCell onClick={() => toggleExpand(key)} sx={{ cursor: "pointer", fontWeight: "bold" }}>{sol.orden || sol.codigo || "-"}</TableCell>
                  <TableCell onClick={() => toggleExpand(key)} sx={{ cursor: "pointer", fontWeight: 600 }}>{formatNombrePaciente(sol)}</TableCell>
                  <TableCell>
                    <Chip
                      label={formatEstadoSolicitud(sol.estadoSolicitud || sol.estatus)}
                      sx={getEstadoSolicitudChipStyles(sol.estadoSolicitud || sol.estatus)}
                      size="small"
                    />
                  </TableCell>
                  <TableCell>{formatFecha(sol.fechaEntrega)}</TableCell>
                  <TableCell align="center">
                    <Tooltip title={todosLiberados ? "Imprimir todos los estudios de esta orden" : "Aún no están liberados todos los estudios"}>
                      <span>
                        <IconButton
                          disabled={!todosLiberados}
                          sx={{ color: todosLiberados ? "#d32f2f" : "#ccc" }}
                          onClick={() => handleImprimirTodos(sol, key)}
                        >
                          <PictureAsPdfIcon />
                        </IconButton>
                      </span>
                    </Tooltip>
                  </TableCell>
                </TableRow>

                {/* Sub-tabla desplegable de estudios */}
                <TableRow>
                  <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
                    <Collapse in={isExp} timeout="auto" unmountOnExit>
                      <Box sx={{ margin: 1, p: 1.5, backgroundColor: "#f4f6f8", borderRadius: "8px" }}>
                        <Table size="small" sx={{ border: "1px solid #cfd8dc", backgroundColor: "#fff" }}>
                          <TableHead>
                            <TableRow sx={{ backgroundColor: "#37474f" }}>
                              <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>Código</TableCell>
                              <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>Estudio</TableCell>
                              <TableCell align="center" sx={{ color: "#fff", fontWeight: "bold" }}>
                                Selecciona un estudio para la impresión
                              </TableCell>
                              <TableCell align="center" sx={{ color: "#fff", fontWeight: "bold" }}>
                                Historial de modificaciones
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {estudios.length > 0 ? (
                              estudios.map((est, stIdx) => {
                                const esLiberado = String(est.estatus || est.estado).toUpperCase() === "L";
                                const isChecked = seleccionados.some((e) => (e.idEstudio || e.id) === (est.idEstudio || est.id));

                                return (
                                  <TableRow key={stIdx}>
                                    <TableCell sx={{ fontWeight: "bold" }}>{est.codigo || "-"}</TableCell>
                                    <TableCell>{est.nombre || est.nombreEstudio || "-"}</TableCell>
                                    <TableCell align="center">
                                      {esLiberado ? (
                                        <Checkbox
                                          checked={isChecked}
                                          onChange={() => handleToggleCheckEstudio(key, est)}
                                          size="small"
                                          color="primary"
                                        />
                                      ) : (
                                        <Typography variant="body2" sx={{ color: "#e65100", fontStyle: "italic", fontWeight: 600 }}>
                                          El estudio aun esta en proceso
                                        </Typography>
                                      )}
                                    </TableCell>
                                    <TableCell align="center">
                                      <Tooltip title="Historial de modificaciones del estudio">
                                        <IconButton
                                          size="small"
                                          sx={{ color: "#1976d2" }}
                                          onClick={() => mostrarModalHistorialEstudio(sol, est)}
                                        >
                                          <HistoryIcon />
                                        </IconButton>
                                      </Tooltip>
                                    </TableCell>
                                  </TableRow>
                                );
                              })
                            ) : (
                              <TableRow>
                                <TableCell colSpan={4} align="center">
                                  Cargando estudios...
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>

                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 1.5, px: 1 }}>
                          <Typography variant="caption" sx={{ fontWeight: 600, color: "#555" }}>
                            Para imprimir algun estudio seleccionelo y de clic en el boton imprimir
                          </Typography>
                          <Button
                            variant="contained"
                            size="small"
                            startIcon={<PrintIcon />}
                            sx={{ backgroundColor: "#18234f", "&:hover": { backgroundColor: "#0d1430" } }}
                            onClick={() => handleImprimirSeleccionados(sol, key)}
                          >
                            Imprimir estudio
                          </Button>
                        </Box>
                      </Box>
                    </Collapse>
                  </TableCell>
                </TableRow>
              </React.Fragment>
            );
          })}
        </TableBody>
      </Table>
    </Box>
  );
};

const ReporteResultados = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const savedState = getReporteState() || {};

  const [expandedSolicitudes, setExpandedSolicitudes] = useState({});
  const [estudiosPorSolicitud, setEstudiosPorSolicitud] = useState({});
  const [loadingEstudios, setLoadingEstudios] = useState({});
  const [solicitudesMap, setSolicitudesMap] = useState({});

  const [filtroTexto, setFiltroTexto] = useState(savedState.filtroTexto || "");
  const [filtroArea, setFiltroArea] = useState(savedState.filtroArea || "todos");
  const [filtroEstado, setFiltroEstado] = useState(savedState.filtroEstado || "todos");
  const [filtroFecha, setFiltroFecha] = useState(savedState.filtroFecha || "3m");
  const [areas, setAreas] = useState([]);

  useEffect(() => {
    document.title = "Reporte de resultados";
  }, []);

  const [estudiosUrgentes, setEstudiosUrgentes] = useState([]);
  const [solicitudesAEntregar, setSolicitudesAEntregar] = useState([]);
  const [solicitudesEntregadas, setSolicitudesEntregadas] = useState([]);
  const [solicitudesHoy, setSolicitudesHoy] = useState([]);
  const [solicitudesPosteriores, setSolicitudesPosteriores] = useState([]);

  const fetchAllStudiesInBackground = async (allRequests) => {
    for (const req of allRequests) {
      if (req.idSolicitud) {
        try {
          const res = await SolicitudesEstudiosService.getEstudiosPorSolicitud(req.idSolicitud);
          const subEstatusRes = await SolicitudesEstudiosService.getEstatusSubPorSolicitud(req.idSolicitud);
          const subEstatusList = subEstatusRes?.estatusSub || [];
          const estudiosList = res?.estudios || [];
          const estudiosConDetalles = await Promise.all(
            estudiosList.map(async (est) => {
              try {
                const estudioDetalle = await EstudiosService.getEstudioPorId(est.idEstudio);

                let subExamenes = [];
                let registroExamenSub = false;

                if (estudioDetalle) {
                  registroExamenSub = estudioDetalle.registroExamenSub === true || estudioDetalle.registroExamenSub === 1 || String(estudioDetalle.registroExamenSub).toLowerCase() === "si";

                  if (registroExamenSub) {
                    const resInt = await EstudiosIntService.getEstudiosPorEstudio(est.idEstudio) || [];
                    for (const sub of resInt) {
                      try {
                        const subDetalle = await EstudiosService.getEstudioPorId(sub.idEstudioSec);
                        if (subDetalle) {
                          const matchSub = subEstatusList.find(se => se.idEstudioSec === sub.idEstudioSec && se.idEstudioPadre === est.idEstudio);
                          const subEstatus = matchSub ? matchSub.estatus : "E";
                          subExamenes.push({
                            idEstudio: sub.idEstudioSec,
                            idEstudioPadre: est.idEstudio,
                            codigo: subDetalle.codigo || "",
                            nombre: subDetalle.nombre || "",
                            esSubrogado: subDetalle.esSubrogado || false,
                            estatus: subEstatus
                          });
                        }
                      } catch (errSub) {
                        console.error("Error fetching sub-study details:", errSub);
                      }
                    }
                  }
                }

                return {
                  ...est,
                  codigo: estudioDetalle?.codigo || "",
                  nombre: estudioDetalle?.nombre || est.nombreEstudio || "",
                  esSubrogado: estudioDetalle?.esSubrogado || false,
                  idArea: estudioDetalle?.idArea,
                  registroExamenSub,
                  subExamenes
                };
              } catch (e) {
                return {
                  ...est,
                  codigo: "",
                  nombre: est.nombreEstudio || "",
                  esSubrogado: false,
                  registroExamenSub: false,
                  subExamenes: []
                };
              }
            })
          );
          setEstudiosPorSolicitud((prev) => ({
            ...prev,
            [req.orden]: estudiosConDetalles,
          }));
        } catch (err) {
          console.error("Error loading background studies for order", req.orden, err);
        }
      }
    }
  };

  const [loadingTabla, setLoadingTabla] = useState(true);

  const fetchUrgentes = async () => {
    setLoadingTabla(true);
    try {
      const response = await SolicitudesService.getSolicitudesResultados();
      const aEntregar = response.data.a_entregar || [];
      const entregadas = response.data.entregadas || [];
      const hoy = response.data.hoy || [];
      const posteriores = response.data.posteriores || [];

      setSolicitudesAEntregar(aEntregar);
      setSolicitudesEntregadas(entregadas);
      setSolicitudesHoy(hoy);
      setSolicitudesPosteriores(posteriores);

      try {
        const responseUrgent = await SolicitudesEstudiosService.getEstudiosUrgentes();
        setEstudiosUrgentes(
          Array.isArray(responseUrgent)
            ? responseUrgent
            : responseUrgent?.estudios || responseUrgent?.data || [],
        );
      } catch (error) {
        console.error("Error cargando estudios urgentes:", error);
      }

    } catch (err) {
      console.error("Error al cargar solicitudes:", err);
    } finally {
      setLoadingTabla(false);
    }
  };

  const coincideBusquedaTexto = (sol, texto) => {
    if (!texto) return true;
    const term = texto.toLowerCase().trim();
    const codigo = String(sol.orden || sol.codigo || "").toLowerCase();
    const paciente = `${sol.nombrePaciente || ""} ${sol.apPaternoPaciente || ""} ${sol.apMaternoPaciente || ""}`.toLowerCase();
    const empresa = String(sol.nombreConvenio || "").toLowerCase();
    return codigo.includes(term) || paciente.includes(term) || empresa.includes(term);
  };

  const coincideArea = (sol, areaId) => {
    if (!areaId || areaId === "todos") return true;
    const studies = estudiosPorSolicitud[sol.orden] || [];
    return studies.some(study => study.idArea === areaId || String(study.idArea) === String(areaId));
  };

  const coincideEstado = (sol, estado) => {
    if (!estado || estado === "todos") return true;
    const studies = estudiosPorSolicitud[sol.orden] || [];
    return studies.some(study => {
      const studyState = study.estado || study.estatus || study.estadoEstudio || "E";
      return studyState === estado;
    });
  };

  const esFechaEnRango = (fechaStr, rango) => {
    if (!rango || rango === "todos") return true;
    if (!fechaStr) return false;
    const fecha = new Date(fechaStr);
    if (Number.isNaN(fecha.getTime())) return true;
    const hoy = new Date();
    const limite = new Date();
    if (rango === "3m") {
      limite.setMonth(hoy.getMonth() - 3);
    } else if (rango === "6m") {
      limite.setMonth(hoy.getMonth() - 6);
    } else if (rango === "1y") {
      limite.setFullYear(hoy.getFullYear() - 1);
    }
    return fecha.getTime() >= limite.getTime();
  };

  const getTimeStampSolicitud = (sol) => {
    const fStr = sol.fecha || sol.fechaSolicitud || sol.fechaCreacion || sol.createdAt || sol.created_at || sol.fechaEntrega;
    if (fStr) {
      const dateVal = new Date(typeof fStr === "string" ? fStr.replace(/-/g, "/") : fStr);
      if (!Number.isNaN(dateVal.getTime())) return dateVal.getTime();
    }
    return Number(sol.idSolicitud || sol.id || sol.orden || 0);
  };

  const filtrarSolicitudes = (lista, esEntregadosTab = false) => {
    return lista
      .filter(sol => {
        if (sol.estadoSolicitud === "C" || sol.estatus === "C") return false;
        const esEntregadaSol = sol.estatusResultados === "EN" || sol.estatus === "EN" || sol.estadoSolicitud === "EN";
        if (esEntregadosTab) {
          if (!esEntregadaSol) return false;
        } else {
          if (esEntregadaSol) return false;
        }
        return coincideBusquedaTexto(sol, filtroTexto) &&
          coincideArea(sol, filtroArea) &&
          coincideEstado(sol, filtroEstado) &&
          esFechaEnRango(sol.fecha || sol.fechaEntrega, filtroFecha);
      })
      .sort((a, b) => {
        const timeA = getTimeStampSolicitud(a);
        const timeB = getTimeStampSolicitud(b);
        if (timeB !== timeA) return timeB - timeA;
        return Number(b.idSolicitud || b.orden || 0) - Number(a.idSolicitud || a.orden || 0);
      });
  };

  const handleLimpiarFiltros = () => {
    setFiltroTexto("");
    setFiltroArea("todos");
    setFiltroEstado("todos");
    setFiltroFecha("3m");
  };

  useEffect(() => {
    const fetchSolicitudesMap = async () => {
      try {
        const response = await SolicitudesService.getSolicitudes();
        const allSols = response.data?.solicitudes || [];
        const map = {};
        allSols.forEach((s) => {
          if (s.codigo) {
            map[s.codigo] = s.idSolicitud;
          }
        });
        setSolicitudesMap(map);
      } catch (error) {
        console.error("Error cargando mapa de solicitudes:", error);
      }
    };

    const fetchAreas = async () => {
      try {
        const resAreas = await AreasService.getAreas();
        setAreas(resAreas.data.areas || []);
      } catch (err) {
        console.error("Error al obtener áreas:", err);
      }
    };

    fetchUrgentes();
    fetchSolicitudesMap();
    fetchAreas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function mostrarMensaje(mensaje) {
    Swal.fire({
      title: "",
      text: mensaje,
      icon: "success",
      confirmButtonText: "Aceptar",
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.reload();
      }
    });
  }
  function mostrarError(mensaje) {
    Swal.fire({
      title: "¡Error!",
      text: mensaje,
      icon: "error",
      confirmButtonText: "Aceptar",
    });
  }

  function reloadPage() {
    window.location.reload();
  }

  const [viewOnly, setViewOnly] = useState(false);
  const [activeTabReportes, setActiveTabReportes] = useState(savedState.activeTabReportes || 0);
  const [paginaActual, setPaginaActual] = useState(savedState.paginaActual || 1);

  useEffect(() => {
    saveReporteState({ filtroTexto, filtroArea, filtroEstado, filtroFecha, paginaActual, activeTabReportes });
  }, [filtroTexto, filtroArea, filtroEstado, filtroFecha, paginaActual, activeTabReportes]);

  const handleTabReportesChange = (event, newValue) => {
    setActiveTabReportes(newValue);
    saveReporteState({ activeTabReportes: newValue });
  };

  const fetchEstudiosForSolicitud = async (orden, idSolicitudDirecta) => {
    const key = String(idSolicitudDirecta || orden);
    setLoadingEstudios((prev) => ({ ...prev, [key]: true, [orden]: true }));
    try {
      const idSolicitud = idSolicitudDirecta || solicitudesMap[orden] || (typeof orden === "number" || /^\d+$/.test(orden) ? orden : null);
      if (idSolicitud) {
        const res = await SolicitudesEstudiosService.getEstudiosPorSolicitud(idSolicitud);
        const subEstatusRes = await SolicitudesEstudiosService.getEstatusSubPorSolicitud(idSolicitud);
        const subEstatusList = subEstatusRes?.estatusSub || [];
        const estudiosList = res?.estudios || [];

        const estudiosConDetalles = await Promise.all(
          estudiosList.map(async (est) => {
            try {
              const estudioDetalle = await EstudiosService.getEstudioPorId(est.idEstudio);

              let subExamenes = [];
              let registroExamenSub = false;

              if (estudioDetalle) {
                registroExamenSub = estudioDetalle.registroExamenSub === true || estudioDetalle.registroExamenSub === 1 || String(estudioDetalle.registroExamenSub).toLowerCase() === "si";

                if (registroExamenSub) {
                  const resInt = await EstudiosIntService.getEstudiosPorEstudio(est.idEstudio) || [];
                  for (const sub of resInt) {
                    try {
                      const subDetalle = await EstudiosService.getEstudioPorId(sub.idEstudioSec);
                      if (subDetalle) {
                        const matchSub = subEstatusList.find(se => se.idEstudioSec === sub.idEstudioSec && se.idEstudioPadre === est.idEstudio);
                        const subEstatus = matchSub ? matchSub.estatus : "E";
                        subExamenes.push({
                          idEstudio: sub.idEstudioSec,
                          idEstudioPadre: est.idEstudio,
                          codigo: subDetalle.codigo || "",
                          nombre: subDetalle.nombre || "",
                          esSubrogado: subDetalle.esSubrogado || false,
                          estatus: subEstatus
                        });
                      }
                    } catch (errSub) {
                      console.error("Error fetching sub-study details:", errSub);
                    }
                  }
                }
              }

              return {
                ...est,
                codigo: estudioDetalle?.codigo || "",
                nombre: estudioDetalle?.nombre || est.nombreEstudio || "",
                esSubrogado: estudioDetalle?.esSubrogado || false,
                registroExamenSub,
                subExamenes
              };
            } catch (e) {
              console.error("Error fetching study details:", e);
              return {
                ...est,
                codigo: "",
                nombre: est.nombreEstudio || "",
                esSubrogado: false,
                registroExamenSub: false,
                subExamenes: []
              };
            }
          })
        );

        setEstudiosPorSolicitud((prev) => ({
          ...prev,
          [key]: estudiosConDetalles,
          [orden]: estudiosConDetalles,
        }));
      } else {
        console.warn("No se encontró idSolicitud para la orden:", orden);
        setEstudiosPorSolicitud((prev) => ({
          ...prev,
          [key]: [],
          [orden]: [],
        }));
      }
    } catch (error) {
      console.error("Error cargando estudios:", error);
    } finally {
      setLoadingEstudios((prev) => ({ ...prev, [key]: false, [orden]: false }));
    }
  };

  const handleToggleExpand = async (orden, idSolicitudDirecta) => {
    const key = String(idSolicitudDirecta || orden);
    const isExpanded = !!expandedSolicitudes[key] || !!expandedSolicitudes[orden];
    setExpandedSolicitudes((prev) => ({
      ...prev,
      [key]: !isExpanded,
      [orden]: !isExpanded,
    }));

    if (!isExpanded) {
      saveReporteState({ openedSolicitud: { orden, idSolicitud: idSolicitudDirecta } });
      if (!estudiosPorSolicitud[key] && !estudiosPorSolicitud[orden]) {
        await fetchEstudiosForSolicitud(orden, idSolicitudDirecta);
      }
    } else {
      saveReporteState({ openedSolicitud: null });
    }
  };

  useEffect(() => {
    try {
      const saved = getReporteState();
      const opened = saved?.openedSolicitud || location.state?.solicitud || location.state?.solicitudRetorno;

      if (opened) {
        const orden = opened.orden || opened.codigo;
        const idSol = opened.idSolicitud || opened.id;
        const key = String(idSol || orden);
        if (key) {
          setExpandedSolicitudes((prev) => ({
            ...prev,
            [key]: true,
            [orden]: true,
          }));

          const intervalId = setInterval(() => {
            fetchEstudiosForSolicitud(orden, idSol);
            clearInterval(intervalId);
          }, 250);
        }
      }
    } catch (e) {
      console.warn("Error al restaurar solicitud previa:", e);
    }
  }, []);

  const handleReportarResultados = async (solicitud, estudio) => {
    saveReporteState({
      openedSolicitud: {
        orden: solicitud.orden || solicitud.codigo,
        idSolicitud: solicitud.idSolicitud || solicitud.id
      }
    });
    try {
      const [params, estudiosIntegrados] = await Promise.all([
        ParametrosEstudioService.getParametrosPorEstudio(estudio.idEstudio).then(res => res || []).catch(() => []),
        EstudiosIntService.getEstudiosPorEstudio(estudio.idEstudio).then(res => res || []).catch(() => [])
      ]);

      if (params.length === 0 && estudiosIntegrados.length === 0) {
        Swal.fire({
          title: "Liberar Estudio",
          text: "Este estudio no tiene parametros, desea liberarlo?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#006787",
          cancelButtonColor: "#888",
          confirmButtonText: "Sí, liberar",
          cancelButtonText: "No"
        }).then(async (result) => {
          if (result.isConfirmed) {
            try {
              const estatusData = {
                idSolicitud: solicitud.idSolicitud || solicitudesMap[solicitud.orden],
                idEstudio: estudio.idEstudio,
                estatus: "L"
              };
              const response = await SolicitudesEstudiosService.updateEstatusEstudio(estatusData, estudio.idEstudio);
              if (response.status === 200 || response.data?.estatus === "OK") {
                // Registrar movimiento en el historial del estudio principal
                await HistorialEstudiosService.registrarMovimiento({
                  idSolicitud: estatusData.idSolicitud,
                  idEstudio: estudio.idEstudioPadre || estudio.idEstudio,
                  nombreEstudio: estudio.nombre || estudio.nombreEstudio || "",
                  nombreEmpleado: currentU?.nombre || "EMPLEADO",
                  tipoAccion: "L",
                });

                mostrarToast("El estudio ha sido liberado correctamente", "success");
                await fetchUrgentes();
                await fetchEstudiosForSolicitud(solicitud.orden, solicitud.idSolicitud || solicitudesMap[solicitud.orden]);
              } else {
                Swal.fire({
                  title: "Error",
                  text: response.data?.mensaje || "No se pudo cambiar el estatus del estudio.",
                  icon: "error",
                  confirmButtonColor: "#006787",
                  confirmButtonText: "Aceptar"
                });
              }
            } catch (err) {
              console.error(err);
              Swal.fire({
                title: "Error",
                text: "Ocurrió un error al intentar liberar el estudio.",
                icon: "error",
                confirmButtonColor: "#006787",
                confirmButtonText: "Aceptar"
              });
            }
          }
        });
      } else {
        navigate("/capturaResultados", { state: { solicitud, estudio, fromApp: true } });
      }
    } catch (error) {
      console.error("Error al validar parámetros del estudio:", error);
      navigate("/capturaResultados", { state: { solicitud, estudio, fromApp: true } });
    }
  };

  const handleHistorialModificaciones = (solicitud, estudio) => {
    mostrarModalHistorialEstudio(solicitud, estudio);
  };

  const handleHistorialImpresionEnvio = (solicitud) => {
    mostrarModalHistorialImpresionEnvio(solicitud);
  };

  const formatFecha = (fecha) => {
    if (!fecha) return "";
    const date = new Date(fecha.replace(/-/g, "/"));
    if (Number.isNaN(date.getTime())) return fecha;
    const meses = [
      "enero",
      "febrero",
      "marzo",
      "abril",
      "mayo",
      "junio",
      "julio",
      "agosto",
      "septiembre",
      "octubre",
      "noviembre",
      "diciembre",
    ];
    return `${date.getDate()} de ${meses[date.getMonth()]} del ${date.getFullYear()}`;
  };

  const formatNombrePaciente = (resultado) => {
    if (!resultado) return "";
    const nombre = resultado.nombrePaciente || "";
    const paterno = resultado.apPaternoPaciente || "";
    const materno = resultado.apMaternoPaciente || "";
    const convenios = resultado.nombreConvenio
      ? ` (${resultado.nombreConvenio})`
      : "";
    return `${nombre} ${paterno} ${materno}${convenios}`.trim();
  };

  const formatTipoEntrega = (tipoEntrega) => {
    if (!tipoEntrega) return "";
    return tipoEntrega;
  };

  const getTipoEntregaChipStyles = (tipoEntrega) => {
    if (tipoEntrega === "Normal") {
      return {
        backgroundColor: "#1976d2",
        color: "#fff",
        fontWeight: 700,
        borderRadius: "8px",
      };
    }
    return {
      backgroundColor: "#9e9e9e",
      color: "#fff",
      fontWeight: 700,
      borderRadius: "8px",
    };
  };

  const formatEstadoSolicitud = (estado) => {
    if (estado === "E" || estado === "P") return "En Proceso";
    if (estado === "R") return "Reportado";
    if (estado === "V") return "Revisado";
    if (estado === "L") return "Liberado";
    if (estado === "EN") return "Entregado";
    if (estado === "RP") return "Resultados Parciales";
    return estado || "";
  };

  const getEstadoSolicitudChipStyles = (estado) => {
    if (estado === "E" || estado === "P") {
      return {
        backgroundColor: "#000",
        color: "#fff",
        fontWeight: 700,
        borderRadius: "8px",
      };
    }
    if (estado === "R") {
      return {
        backgroundColor: "#1976d2",
        color: "#fff",
        fontWeight: 700,
        borderRadius: "8px",
      };
    }
    if (estado === "V") {
      return {
        backgroundColor: "#ff9800",
        color: "#000",
        fontWeight: 700,
        borderRadius: "8px",
      };
    }
    if (estado === "L" || estado === "EN") {
      return {
        backgroundColor: "#4caf50",
        color: "#000",
        fontWeight: 700,
        borderRadius: "8px",
      };
    }
    if (estado === "RP") {
      return {
        backgroundColor: "#ffb300", // Color Ámbar / Oro
        color: "#000",
        fontWeight: 700,
        borderRadius: "8px",
      };
    }
    return {
      backgroundColor: "#9e9e9e",
      color: "#fff",
      fontWeight: 700,
      borderRadius: "8px",
    };
  };

  const MySwal = withReactContent(Swal);

  const getSolicitudesDelPaciente = (resultado) => {
    const todas = [
      ...solicitudesAEntregar,
      ...solicitudesEntregadas,
      ...solicitudesHoy,
      ...solicitudesPosteriores
    ];

    const idPacTarget = resultado?.idPaciente || resultado?.pacienteId;
    const nomTarget = `${resultado?.nombrePaciente || ""} ${resultado?.apPaternoPaciente || ""} ${resultado?.apMaternoPaciente || ""}`.trim().toLowerCase();

    const filtradas = todas.filter((s) => {
      const idPacS = s.idPaciente || s.pacienteId;
      if (idPacTarget && idPacS) {
        return String(idPacS) === String(idPacTarget);
      }
      const nomS = `${s.nombrePaciente || ""} ${s.apPaternoPaciente || ""} ${s.apMaternoPaciente || ""}`.trim().toLowerCase();
      return nomS && nomS === nomTarget;
    });

    return filtradas.length > 0 ? filtradas : [resultado];
  };

  const getVisitasPaciente = (resultado) => {
    const lista = getSolicitudesDelPaciente(resultado);
    return lista.length;
  };

  const handleAbrirExpedientePaciente = (resultado) => {
    const solicitudesPac = getSolicitudesDelPaciente(resultado);
    const nomPac = formatNombrePaciente(resultado);

    MySwal.fire({
      width: "85vw",
      showConfirmButton: false,
      showCloseButton: true,
      customClass: {
        popup: "swalMaxHeight",
      },
      html: (
        <ModalExpedienteContent
          paciente={nomPac}
          solicitudesPaciente={solicitudesPac}
          formatNombrePaciente={formatNombrePaciente}
          formatEstadoSolicitud={formatEstadoSolicitud}
          getEstadoSolicitudChipStyles={getEstadoSolicitudChipStyles}
          formatFecha={formatFecha}
        />
      ),
    });
  };

  const renderTablaSolicitudes = (solicitudes, esEntregadosTab = false) => {
    if (loadingTabla) {
      return (
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "35vh", py: 5 }}>
          <CircularProgress size={50} sx={{ color: "#18234f", mb: 2 }} />
          <Typography sx={{ fontSize: "1.1rem", fontWeight: "bold", color: "#18234f" }}>
            Cargando reporte de resultados...
          </Typography>
        </Box>
      );
    }

    const itemsPorPagina = 10;
    const totalPaginas = Math.ceil(solicitudes.length / itemsPorPagina) || 1;
    const currentPage = Math.min(paginaActual, totalPaginas);
    const startIdx = (currentPage - 1) * itemsPorPagina;
    const endIdx = startIdx + itemsPorPagina;
    const solicitudesPaginadas = solicitudes.slice(startIdx, endIdx);

    // Pre-cargar estudios en segundo plano únicamente de los 10 registros visibles para respuesta instantánea al primer clic
    solicitudesPaginadas.forEach((resultado) => {
      const key = String(resultado.idSolicitud || resultado.orden);
      if (resultado.idSolicitud && !estudiosPorSolicitud[key] && !estudiosPorSolicitud[resultado.orden] && !loadingEstudios[key]) {
        fetchEstudiosForSolicitud(resultado.orden, resultado.idSolicitud);
      }
    });

    return (
      <Box sx={{ transform: "scale(0.765)", transformOrigin: "top left", width: "130.7%", marginRight: "-30.7%" }}>
        <Table sx={{ width: "100%", minWidth: "750px", backgroundColor: "white", "& .MuiTableCell-root": { padding: "4px 8px" } }}>
          <TableHead sx={{ backgroundColor: "#18234f" }}>
            <TableRow>
              <TableCell
                sx={{
                  color: "white",
                  fontWeight: "bold",
                  borderBottom: "none",
                  borderRight: "1px solid #ccc",
                  fontSize: "1vw"
                }}
              >
                Ver
              </TableCell>
              <TableCell
                sx={{
                  color: "white",
                  fontWeight: "bold",
                  borderBottom: "none",
                  borderRight: "1px solid #ccc",
                }}
              >
                Sucursal
              </TableCell>
              <TableCell
                sx={{
                  color: "white",
                  fontWeight: "bold",
                  borderBottom: "none",
                  borderRight: "1px solid #ccc",
                }}
              >
                Orden
              </TableCell>
              <TableCell
                sx={{
                  width: "150px",
                  minWidth: "150px",
                  color: "white",
                  fontWeight: "bold",
                  borderBottom: "none",
                  borderRight: "1px solid #ccc",
                }}
              >
                Fecha de entrega
              </TableCell>
              <TableCell
                sx={{
                  width: "6vw",
                  color: "white",
                  fontWeight: "bold",
                  borderBottom: "none",
                  borderRight: "1px solid #ccc",
                }}
              >
                Nombre del paciente
              </TableCell>
              {!esEntregadosTab && (
                <TableCell
                  sx={{
                    color: "white",
                    fontWeight: "bold",
                    borderBottom: "none",
                    borderRight: "1px solid #ccc",
                  }}
                >
                  Tipo de entrega
                </TableCell>
              )}
              <TableCell
                sx={{
                  color: "white",
                  fontWeight: "bold",
                  borderBottom: "none",
                  borderRight: "1px solid #ccc",
                }}
              >
                Estado de la solicitud
              </TableCell>
              {!esEntregadosTab && (
                <TableCell
                  sx={{
                    color: "white",
                    fontWeight: "bold",
                    borderBottom: "none",
                    borderRight: "1px solid #ccc",
                  }}
                >
                  Expediente del paciente
                </TableCell>
              )}
              {esEntregadosTab && (
                <TableCell
                  align="center"
                  sx={{
                    color: "white",
                    fontWeight: "bold",
                    borderBottom: "none",
                    borderRight: "1px solid #ccc",
                  }}
                >
                  Historial Impresión Envío
                </TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {solicitudesPaginadas.length > 0 ? (
              solicitudesPaginadas.map((resultado, index) => {
                const orden = resultado.orden;
                const key = String(resultado.idSolicitud || orden);
                const isExpanded = !!expandedSolicitudes[key] || !!expandedSolicitudes[orden];
                const studies = estudiosPorSolicitud[key] || estudiosPorSolicitud[orden] || [];
                const isLoading = !!loadingEstudios[key] || !!loadingEstudios[orden];

                return (
                  <React.Fragment key={index}>
                    <TableRow>
                      <TableCell>
                        <Box sx={{ display: "flex", justifyContent: "center" }}>
                          <IconButton
                            sx={{ color: "#1976d2" }}
                            onClick={() => handleToggleExpand(orden, resultado.idSolicitud)}
                          >
                            {isExpanded ? (
                              <KeyboardArrowDownIcon sx={{ fontSize: "1.5rem" }} />
                            ) : (
                              <ArrowForwardIosIcon sx={{ fontSize: "1.3rem" }} />
                            )}
                          </IconButton>
                        </Box>
                      </TableCell>
                      <TableCell
                        onClick={() => handleToggleExpand(orden, resultado.idSolicitud)}
                        sx={{ cursor: "pointer" }}
                      >
                        <Box sx={{ display: "flex", justifyContent: "center" }}>
                          <Chip
                            label={resultado.sucursal || ""}
                            sx={{
                              backgroundColor: "#e0e0e0",
                              color: "#000",
                              fontWeight: 700,
                              borderRadius: "8px",
                              px: 1.2,
                              py: 0.6,
                              cursor: "pointer",
                            }}
                          />
                        </Box>
                      </TableCell>
                      <TableCell
                        onClick={() => handleToggleExpand(orden, resultado.idSolicitud)}
                        sx={{ cursor: "pointer" }}
                      >
                        <Box sx={{ display: "flex", justifyContent: "center" }}>
                          <Typography sx={{ fontWeight: 700, color: "#000", cursor: "pointer" }}>
                            {resultado.orden || ""}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell
                        onClick={() => handleToggleExpand(orden, resultado.idSolicitud)}
                        sx={{ width: "150px", minWidth: "150px", cursor: "pointer" }}
                      >
                        <Box sx={{ display: "flex", justifyContent: "center" }}>
                          <Typography sx={{ color: "#000", cursor: "pointer" }}>
                            {formatFecha(resultado.fechaEntrega)}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell
                        onClick={() => handleToggleExpand(orden, resultado.idSolicitud)}
                        sx={{ width: "220px", minWidth: "220px", cursor: "pointer" }}
                      >
                        <Box sx={{ display: "flex", justifyContent: "center" }}>
                          <Typography sx={{ fontWeight: 700, color: "#000", cursor: "pointer" }}>
                            {formatNombrePaciente(resultado)}
                          </Typography>
                        </Box>
                      </TableCell>
                      {!esEntregadosTab && (
                        <TableCell>
                          <Box sx={{ display: "flex", justifyContent: "center" }}>
                            <Chip
                              label={formatTipoEntrega(resultado.tipoEntrega)}
                              sx={getTipoEntregaChipStyles(resultado.tipoEntrega)}
                            />
                          </Box>
                        </TableCell>
                      )}
                      <TableCell>
                        <Box sx={{ display: "flex", justifyContent: "center" }}>
                          <Chip
                            label={formatEstadoSolicitud(resultado.estadoSolicitud || resultado.estatus)}
                            sx={getEstadoSolicitudChipStyles(resultado.estadoSolicitud || resultado.estatus)}
                          />
                        </Box>
                      </TableCell>
                      {!esEntregadosTab && (
                        <TableCell>
                          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <Tooltip title="Ver expediente del paciente">
                              <IconButton
                                sx={{ color: "#1976d2" }}
                                onClick={() => handleAbrirExpedientePaciente(resultado)}
                              >
                                <CalendarMonthIcon sx={{ fontSize: "2.3rem" }} />
                              </IconButton>
                            </Tooltip>
                            <Typography sx={{ fontSize: "0.72rem", fontWeight: 700, color: "#444", mt: -0.5, textAlign: "center" }}>
                              {getVisitasPaciente(resultado)} {getVisitasPaciente(resultado) === 1 ? "visita" : "visitas"}
                            </Typography>
                          </Box>
                        </TableCell>
                      )}
                      {esEntregadosTab && (
                        <TableCell>
                          <Box sx={{ display: "flex", justifyContent: "center" }}>
                            <IconButton sx={{ color: "#1976d2" }} onClick={() => handleHistorialImpresionEnvio(resultado)}>
                              <DescriptionIcon sx={{ fontSize: "2.1rem" }} />
                            </IconButton>
                          </Box>
                        </TableCell>
                      )}
                    </TableRow>
                    <TableRow sx={{ backgroundColor: isExpanded ? "#f9f9f9" : "transparent" }}>
                      <TableCell colSpan={esEntregadosTab ? 7 : 8} sx={{ p: 0, borderBottom: isExpanded ? "1px solid #ccc" : "none" }}>
                        <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                          <Box sx={{ p: 2 }}>
                            <Box sx={{ width: "95%", mx: "auto", my: 1, borderRadius: "8px", overflow: "hidden", border: "1px solid #ccc", boxShadow: "0px 2px 4px rgba(0,0,0,0.08)" }}>
                              {isLoading ? (
                                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", py: 2.5, gap: 1.5, backgroundColor: "#fff" }}>
                                  <CircularProgress size={24} sx={{ color: "#18234f" }} />
                                  <Typography sx={{ fontWeight: 500, color: "#18234f", fontSize: "0.9rem" }}>Cargando estudios...</Typography>
                                </Box>
                              ) : studies.length > 0 ? (
                                (() => {
                                  const tieneUrgente = studies.some(study => study.urgente === true || study.urgente === 1 || study.urgente === "true");
                                  return (
                                    <Table size="small" sx={{ width: "100%", backgroundColor: "#fff" }}>
                                      <TableHead sx={{ backgroundColor: "#d0e1eb" }}>
                                        <TableRow>
                                          <TableCell align="center" sx={{ color: "#18234f", fontWeight: "bold", borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc", py: 1.5 }}>Código</TableCell>
                                          <TableCell align="left" sx={{ color: "#18234f", fontWeight: "bold", borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc", py: 1.5 }}>Estudio</TableCell>
                                          {!esEntregadosTab && resultado.estadoSolicitud !== "EN" && (
                                            <TableCell align="center" sx={{ color: "#18234f", fontWeight: "bold", borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc", py: 1.5 }}>Estado del Estudio</TableCell>
                                          )}
                                          {!esEntregadosTab && resultado.estadoSolicitud !== "EN" && (
                                            <TableCell align="center" sx={{ color: "#18234f", fontWeight: "bold", borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc", py: 1.5 }}>Reportar Resultados</TableCell>
                                          )}
                                          {!esEntregadosTab && tieneUrgente && (
                                            <TableCell align="center" sx={{ color: "#18234f", fontWeight: "bold", borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc", py: 1.5 }}>Urgente</TableCell>
                                          )}
                                          {esEntregadosTab && (
                                            <TableCell align="center" sx={{ color: "#18234f", fontWeight: "bold", borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc", py: 1.5 }}>Fecha de entrega</TableCell>
                                          )}
                                          <TableCell align="center" sx={{ color: "#18234f", fontWeight: "bold", borderBottom: "1px solid #ccc", py: 1.5 }}>Historial de Modificaciones</TableCell>
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        {(() => {
                                          const listadoFiltrado = studies.filter(est => {
                                            const esHijo = studies.some(parentEst =>
                                              parentEst.registroExamenSub &&
                                              (parentEst.subExamenes || []).some(sub => sub.idEstudio === est.idEstudio)
                                            );
                                            return !esHijo;
                                          });
                                          return listadoFiltrado.map((study, sIdx) => {
                                            const studyState = study.estado || study.estatus || study.estadoEstudio || "E";
                                            return (
                                              <React.Fragment key={sIdx}>
                                                <TableRow sx={{ "&:hover": { backgroundColor: "#f5f5f5" } }}>
                                                  <TableCell align="center" sx={{ borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc", fontWeight: "bold", py: 1.5 }}>
                                                    {study.codigo || study.idEstudio}
                                                  </TableCell>
                                                  <TableCell align="left" sx={{ borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc", fontWeight: "bold", textTransform: "uppercase", py: 1.5 }}>
                                                    {study.nombre || study.nombreEstudio || ""}
                                                  </TableCell>
                                                  {!esEntregadosTab && resultado.estadoSolicitud !== "EN" && (
                                                    <TableCell align="center" sx={{ borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc", py: 1.5 }}>
                                                      <Chip
                                                        label={formatEstadoSolicitud(studyState)}
                                                        sx={getEstadoSolicitudChipStyles(studyState)}
                                                        size="small"
                                                      />
                                                    </TableCell>
                                                  )}
                                                  {!esEntregadosTab && resultado.estadoSolicitud !== "EN" && (
                                                    <TableCell align="center" sx={{ borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc", py: 0.5 }}>
                                                      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                                                        <IconButton
                                                          onClick={() => handleReportarResultados(resultado, study)}
                                                          sx={{
                                                            color: "#1976d2",
                                                            "&:hover": {
                                                              backgroundColor: "rgba(25, 118, 210, 0.1)"
                                                            }
                                                          }}
                                                        >
                                                          <AssignmentIcon sx={{ fontSize: "2.3rem" }} />
                                                        </IconButton>
                                                        {study.esSubrogado && (
                                                          <Typography sx={{ fontSize: "0.75rem", color: "#666", fontWeight: "bold", mt: -0.5 }}>
                                                            (subrogado)
                                                          </Typography>
                                                        )}
                                                      </Box>
                                                    </TableCell>
                                                  )}
                                                  {!esEntregadosTab && tieneUrgente && (
                                                    <TableCell align="center" sx={{ borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc", py: 0.5 }}>
                                                      {study.urgente ? (
                                                        (() => {
                                                          const hoy = new Date();
                                                          hoy.setHours(0, 0, 0, 0);
                                                          const fechaEstudio = study.fechaEntrega ? new Date(study.fechaEntrega.replace(/-/g, "/")) : null;
                                                          if (fechaEstudio) {
                                                            fechaEstudio.setHours(0, 0, 0, 0);
                                                          }
                                                          const esAtrasada = fechaEstudio && fechaEstudio.getTime() <= hoy.getTime();
                                                          return (
                                                            <Typography sx={{ fontWeight: "bold", color: esAtrasada ? "#c62828" : "black", fontSize: "0.8rem" }}>
                                                              {formatFecha(study.fechaEntrega)}
                                                            </Typography>
                                                          );
                                                        })()
                                                      ) : "-"}
                                                    </TableCell>
                                                  )}
                                                  {esEntregadosTab && (
                                                    <TableCell align="center" sx={{ borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc", py: 1.5 }}>
                                                      <Typography sx={{ color: "#000", fontSize: "0.85rem" }}>
                                                        {formatFecha(study.fechaEntrega || resultado.fechaEntrega)}
                                                      </Typography>
                                                    </TableCell>
                                                  )}
                                                  <TableCell align="center" sx={{ borderBottom: "1px solid #ccc", py: 0.5 }}>
                                                    <Button
                                                      variant="contained"
                                                      size="small"
                                                      onClick={() => handleHistorialModificaciones(resultado, study)}
                                                      sx={{
                                                        backgroundColor: "#4caf50",
                                                        color: "white",
                                                        minWidth: "40px",
                                                        width: "40px",
                                                        height: "32px",
                                                        borderRadius: "4px",
                                                        "&:hover": {
                                                          backgroundColor: "#388e3c"
                                                        }
                                                      }}
                                                    >
                                                      <VisibilityIcon sx={{ fontSize: "1.2rem", color: "white" }} />
                                                    </Button>
                                                  </TableCell>
                                                </TableRow>
                                                {study.registroExamenSub && (study.subExamenes || []).map((sub, subIdx) => {
                                                  return (
                                                    <TableRow key={`sub-${subIdx}`} sx={{ "&:hover": { backgroundColor: "#f5f5f5" } }}>
                                                      <TableCell align="center" sx={{ borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc", py: 1.5 }} />
                                                      <TableCell align="left" sx={{ borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc", py: 1.5 }}>
                                                        <span style={{ marginLeft: "1.5vw", textTransform: "uppercase" }}>{sub.nombre}</span>
                                                      </TableCell>
                                                      {!esEntregadosTab && resultado.estadoSolicitud !== "EN" && (
                                                        <TableCell align="center" sx={{ borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc", py: 1.5 }}>
                                                          <Chip
                                                            label={formatEstadoSolicitud(sub.estatus || "E")}
                                                            sx={getEstadoSolicitudChipStyles(sub.estatus || "E")}
                                                            size="small"
                                                          />
                                                        </TableCell>
                                                      )}
                                                      {!esEntregadosTab && resultado.estadoSolicitud !== "EN" && (
                                                        <TableCell align="center" sx={{ borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc", py: 0.5 }}>
                                                          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                                                            <IconButton
                                                              onClick={() => handleReportarResultados(resultado, sub)}
                                                              sx={{
                                                                color: "#1976d2",
                                                                "&:hover": {
                                                                  backgroundColor: "rgba(25, 118, 210, 0.1)"
                                                                }
                                                              }}
                                                            >
                                                              <EditIcon sx={{ fontSize: "2rem" }} />
                                                            </IconButton>
                                                          </Box>
                                                        </TableCell>
                                                      )}
                                                      {!esEntregadosTab && tieneUrgente && (
                                                        <TableCell align="center" sx={{ borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc", py: 0.5 }}>
                                                          -
                                                        </TableCell>
                                                      )}
                                                      {esEntregadosTab && (
                                                        <TableCell align="center" sx={{ borderRight: "1px solid #ccc", borderBottom: "1px solid #ccc", py: 1.5 }}>
                                                          <Typography sx={{ color: "#000", fontSize: "0.85rem" }}>
                                                            {formatFecha(sub.fechaEntrega || resultado.fechaEntrega)}
                                                          </Typography>
                                                        </TableCell>
                                                      )}
                                                      <TableCell align="center" sx={{ borderBottom: "1px solid #ccc", py: 0.5 }}>
                                                        -
                                                      </TableCell>
                                                    </TableRow>
                                                  );
                                                })}
                                              </React.Fragment>
                                            );
                                          });
                                        })()}
                                      </TableBody>
                                    </Table>
                                  );
                                })()
                              ) : (
                                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", py: 3, backgroundColor: "#fff" }}>
                                  <Typography sx={{ color: "#666" }}>No hay estudios registrados para esta solicitud.</Typography>
                                </Box>
                              )}
                            </Box>
                          </Box>
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  </React.Fragment>
                );
              })
            ) : (
              <TableRow>
                <TableCell colSpan={esEntregadosTab ? 7 : 8} align="center" sx={{ py: 4 }}>
                  No hay registros
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>

        {totalPaginas > 1 && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "0.5vw",
              marginTop: "1.5vw",
              marginBottom: "1vw",
            }}
          >
            <IconButton
              onClick={() => setPaginaActual((prev) => Math.max(1, prev - 1))}
              disabled={currentPage === 1}
              sx={{
                backgroundColor: "#f0f0f0",
                color: "#18234f",
                "&:hover": { backgroundColor: "#d9eaf7" },
                "&.Mui-disabled": { backgroundColor: "#f5f5f5", color: "#ccc" },
                borderRadius: "8px",
                padding: "0.5vw",
              }}
            >
              <ArrowBackIosIcon sx={{ fontSize: "1vw", marginLeft: "0.3vw" }} />
            </IconButton>

            {(() => {
              let startPage = 1;
              if (currentPage >= 10) {
                startPage = 1 + 5 * Math.floor((currentPage - 5) / 5);
              }
              const endPage = Math.min(totalPaginas, startPage + 9);

              const buttons = [];
              for (let i = startPage; i <= endPage; i++) {
                const isActive = i === currentPage;
                buttons.push(
                  <Button
                    key={i}
                    onClick={() => setPaginaActual(i)}
                    sx={{
                      minWidth: "2.5vw",
                      height: "2.5vw",
                      backgroundColor: isActive ? "#014e65" : "#f0f0f0",
                      color: isActive ? "white" : "black",
                      fontWeight: "bold",
                      fontSize: "0.9vw",
                      borderRadius: "8px",
                      border: "none",
                      "&:hover": {
                        backgroundColor: isActive ? "#013240" : "#d9eaf7",
                      },
                      padding: 0,
                    }}
                  >
                    {i}
                  </Button>
                );
              }
              return buttons;
            })()}

            <IconButton
              onClick={() => setPaginaActual((prev) => Math.min(totalPaginas, prev + 1))}
              disabled={currentPage === totalPaginas}
              sx={{
                backgroundColor: "#f0f0f0",
                color: "#18234f",
                "&:hover": { backgroundColor: "#d9eaf7" },
                "&.Mui-disabled": { backgroundColor: "#f5f5f5", color: "#ccc" },
                borderRadius: "8px",
                padding: "0.5vw",
              }}
            >
              <ArrowForwardIosIcon sx={{ fontSize: "1vw" }} />
            </IconButton>
          </Box>
        )}
      </Box>
    );
  };

  const TabPanel = ({ children, value, index }) => (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
    >
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );

  const usuarioString = sessionStorage.getItem("usuario");
  const currentU = JSON.parse(usuarioString);

  return (
    <Layout>
      <Content>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            height: "50%",
            paddingTop: "2vh",
            paddingBottom: "2vh",
            width: "100%",
          }}
        >
          <Stack spacing={2} sx={{ width: "100%", pl: "3vw", pr: "10vw", boxSizing: "border-box" }}>
            <Paper
              elevation={3}
              sx={{ p: 2, borderRadius: 4, width: "100%" }}
              className="paperSol"
            >
              <Grid item xs={12}>
                <Table sx={{ width: "100%", mb: 2, backgroundColor: "#c62828", "& .MuiTableCell-root": { padding: "4px 8px" } }}>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        colSpan={6}
                        align="center"
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          backgroundColor: "#c62828",
                          fontSize: "1.1rem",
                        }}
                      >
                        RESULTADOS QUE ESTAN POR ENTREGARSE
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {estudiosUrgentes.slice(0, 10).map((item, index) => (
                      <TableRow key={index} sx={{ backgroundColor: "#c62828" }}>
                        <TableCell sx={{ color: "white", backgroundColor: "#c62828" }}>{index + 1}</TableCell>
                        <TableCell sx={{ color: "white", backgroundColor: "#c62828" }}>{item.nombreSucursal || ""}</TableCell>
                        <TableCell sx={{ color: "white", backgroundColor: "#c62828" }}>{item.codigoSolicitud || ""}</TableCell>
                        <TableCell sx={{ color: "white", backgroundColor: "#c62828" }}>{item.nombreEstudio || ""}</TableCell>
                        <TableCell sx={{ color: "white", backgroundColor: "#c62828" }}>{item.nombrePaciente || ""}</TableCell>
                        <TableCell sx={{ color: "white", backgroundColor: "#c62828" }}>{item.fechaEntrega || ""}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Grid>
              <Grid item xs={12}>
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    variant="h9"
                    gutterBottom
                    sx={{
                      background: "linear-gradient(90deg, #006787, #014e65)",
                      color: "white",
                      padding: "0.5vw 1vw",
                      borderRadius: "8px",
                      display: "inline-block",
                      whiteSpace: "pre-line",
                      textAlign: "center",
                      fontWeight: "bold"
                    }}
                  >
                    <Box
                      component="span"
                      sx={{ fontWeight: "bold", justifyContent: "center" }}
                    >
                      REPORTE DE RESULTADOS
                    </Box>
                  </Typography>
                </Box>
              </Grid>

              {/* Contenedor principal */}
              <Grid container spacing={"0.3vw"}>
                <Grid
                  item
                  xs={12}
                  container
                  spacing={"1vw"}
                  sx={{
                    paddingTop: "0.6vw",
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <Stack direction="row" spacing={"3vw"} sx={{ width: "100%" }}>
                    <Grid item xs={12} sx={{ width: "100%" }}>
                      <Table sx={{ width: "100%", backgroundColor: "white", "& .MuiTableCell-root": { padding: "4px 8px" } }}>
                        {" "}
                        <TableHead sx={{ backgroundColor: "#18234f" }}>
                          <TableRow>
                            <TableCell
                              colSpan={3}
                              align="center"
                              sx={{
                                fontSize: "1.5vw",
                                color: "white",
                                fontWeight: "bold",
                                borderBottom: "none",
                                borderRight: "1px solid #ccc",
                              }}
                            >
                              Filtros
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody
                          sx={{
                            "& .MuiTableCell-root": { padding: "4px 6px" },
                          }}
                        >
                          <TableRow>
                            <TableCell>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <Typography
                                  variant="h9"
                                  gutterBottom
                                  sx={{
                                    fontWeight: "bold",
                                    color: "black",
                                    padding: "0.5vw 1vw",
                                    borderRadius: "8px",
                                    display: "inline-block",

                                    textAlign: "center",
                                  }}
                                >
                                  Coloque el codigo de la solicitud, nombre del
                                  paciente o nombre de empresa:
                                </Typography>
                              </Box>
                            </TableCell>
                            <TableCell>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <TextField
                                  disabled={viewOnly}
                                  value={filtroTexto}
                                  onChange={(e) => setFiltroTexto(e.target.value)}
                                  sx={{
                                    width: "14vw",
                                    "& .MuiInputBase-root": {
                                      height: "5vh",
                                    },
                                    "& .MuiInputBase-input": {
                                      fontSize: "1vw",
                                    },
                                  }}
                                />
                              </Box>
                            </TableCell>
                            <TableCell>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <Button
                                  size="medium"
                                  onClick={handleLimpiarFiltros}
                                  sx={{
                                    backgroundColor: "#18234f",
                                    color: "white",
                                  }}
                                >
                                  Mostrar todos
                                </Button>
                              </Box>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                }}
                              >
                                <Typography
                                  variant="h9"
                                  gutterBottom
                                  sx={{
                                    fontWeight: "bold",
                                    color: "black",
                                    padding: "0.5vw 1vw",
                                    borderRadius: "8px",
                                    display: "inline-block",

                                    textAlign: "center",
                                  }}
                                >
                                  Área:
                                </Typography>
                              </Box>
                            </TableCell>
                            <TableCell>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <Select
                                  input={<OutlinedInput />}
                                  disabled={viewOnly}
                                  value={filtroArea}
                                  onChange={async (e) => {
                                    const val = e.target.value;
                                    setFiltroArea(val);
                                    if (val !== "todos") {
                                      setLoadingTabla(true);
                                      try {
                                        const allRequests = [...solicitudesAEntregar, ...solicitudesEntregadas, ...solicitudesHoy, ...solicitudesPosteriores];
                                        await fetchAllStudiesInBackground(allRequests);
                                      } finally {
                                        setLoadingTabla(false);
                                      }
                                    }
                                  }}
                                  sx={{
                                    width: "14vw",
                                    height: "5vh",
                                    minHeight: "0px !important",
                                    overflow: "hidden",
                                    "&.MuiInputBase-root": {
                                      minHeight: "0px !important",
                                    },
                                    "& .MuiSelect-select": {
                                      minHeight: "0px !important",
                                      padding: "0 0.5vw !important",
                                      display: "flex",
                                      alignItems: "center",
                                      fontSize: "1vw",
                                      lineHeight: "1",
                                    },
                                    "& .MuiOutlinedInput-notchedOutline": {
                                      top: 0,
                                      "& legend": { display: "none" },
                                    },
                                    "& .MuiSvgIcon-root": {
                                      display: "inline-block !important",
                                      position: "absolute",
                                      right: "0.5vw",
                                      top: "50%",
                                      transform: "translateY(-50%)",
                                      fontSize: "1.2vw !important",
                                      width: "1.2vw !important",
                                      height: "1.2vw !important",
                                      pointerEvents: "none",
                                    },
                                    minWidth: "0px !important",
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis",
                                  }}
                                  className="selectArea"
                                >
                                  <MenuItem
                                    sx={{
                                      fontSize: "1vw",
                                      padding: "0.5vw",
                                    }}
                                    value="todos"
                                  >
                                    Todos
                                  </MenuItem>
                                  {areas.map((area) => (
                                    <MenuItem
                                      key={area.idArea}
                                      sx={{
                                        fontSize: "1vw",
                                        padding: "0.5vw",
                                      }}
                                      value={area.idArea}
                                    >
                                      {area.nombre}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </Box>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                }}
                              >
                                <Typography
                                  variant="h9"
                                  gutterBottom
                                  sx={{
                                    fontWeight: "bold",
                                    color: "black",
                                    padding: "0.5vw 1vw",
                                    borderRadius: "8px",
                                    display: "inline-block",

                                    textAlign: "center",
                                  }}
                                >
                                  Estado de reporte:
                                </Typography>
                              </Box>
                            </TableCell>
                            <TableCell>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <Select
                                  input={<OutlinedInput />}
                                  disabled={viewOnly}
                                  value={filtroEstado}
                                  onChange={(e) => setFiltroEstado(e.target.value)}
                                  sx={{

                                    width: "14vw",


                                    height: "5vh",
                                    minHeight: "0px !important",
                                    overflow: "hidden",


                                    "&.MuiInputBase-root": {
                                      minHeight: "0px !important",
                                    },

                                    "& .MuiSelect-select": {
                                      minHeight: "0px !important",
                                      padding: "0 0.5vw !important",
                                      display: "flex",
                                      alignItems: "center",
                                      fontSize: "1vw",
                                      lineHeight: "1",
                                    },

                                    "& .MuiOutlinedInput-notchedOutline": {

                                      top: 0,
                                      "& legend": { display: "none" },
                                    },

                                    "& .MuiSvgIcon-root": {
                                      display: "inline-block !important",
                                      position: "absolute",
                                      right: "0.5vw",
                                      top: "50%",
                                      transform: "translateY(-50%)",
                                      fontSize: "1.2vw !important",
                                      width: "1.2vw !important",
                                      height: "1.2vw !important",
                                      pointerEvents: "none",

                                    },
                                    minWidth: "0px !important",
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis",
                                  }}
                                  className="selectoEstadoReporte"
                                >
                                  <MenuItem
                                    sx={{
                                      fontSize: "1vw",
                                      padding: "0.5vw",
                                    }}
                                    value="todos"
                                  >
                                    Todos
                                  </MenuItem>
                                  <MenuItem sx={{ fontSize: "1vw", padding: "0.5vw" }} value="L">Liberado</MenuItem>
                                  <MenuItem sx={{ fontSize: "1vw", padding: "0.5vw" }} value="V">Revisado</MenuItem>
                                  <MenuItem sx={{ fontSize: "1vw", padding: "0.5vw" }} value="R">Reportado</MenuItem>
                                  <MenuItem sx={{ fontSize: "1vw", padding: "0.5vw" }} value="E">En Proceso</MenuItem>
                                </Select>
                              </Box>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                }}
                              >
                                <Typography
                                  variant="h9"
                                  gutterBottom
                                  sx={{
                                    fontWeight: "bold",
                                    color: "black",
                                    padding: "0.5vw 1vw",
                                    borderRadius: "8px",
                                    display: "inline-block",

                                    textAlign: "center",
                                  }}
                                >
                                  Busqueda por fechas:
                                </Typography>
                              </Box>
                            </TableCell>

                            <TableCell>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <Select
                                  input={<OutlinedInput />}
                                  disabled={viewOnly}
                                  value={filtroFecha}
                                  onChange={(e) => setFiltroFecha(e.target.value)}
                                  sx={{

                                    width: "14vw",


                                    height: "5vh",
                                    minHeight: "0px !important",
                                    overflow: "hidden",


                                    "&.MuiInputBase-root": {
                                      minHeight: "0px !important",
                                    },

                                    "& .MuiSelect-select": {
                                      minHeight: "0px !important",
                                      padding: "0 0.5vw !important",
                                      display: "flex",
                                      alignItems: "center",
                                      fontSize: "1vw",
                                      lineHeight: "1",
                                    },

                                    "& .MuiOutlinedInput-notchedOutline": {

                                      top: 0,
                                      "& legend": { display: "none" },
                                    },

                                    "& .MuiSvgIcon-root": {
                                      display: "inline-block !important",
                                      position: "absolute",
                                      right: "0.5vw",
                                      top: "50%",
                                      transform: "translateY(-50%)",
                                      fontSize: "1.2vw !important",
                                      width: "1.2vw !important",
                                      height: "1.2vw !important",
                                      pointerEvents: "none",

                                    },
                                    minWidth: "0px !important",
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis",
                                  }}
                                  className="selectFechas"
                                >
                                  <MenuItem
                                    sx={{
                                      fontSize: "1vw",
                                      padding: "0.5vw",
                                    }}
                                    value="todos"
                                  >
                                    Todos
                                  </MenuItem>
                                  <MenuItem sx={{ fontSize: "1vw", padding: "0.5vw" }} value="3m">Últimos 3 meses</MenuItem>
                                  <MenuItem sx={{ fontSize: "1vw", padding: "0.5vw" }} value="6m">Últimos 6 meses</MenuItem>
                                  <MenuItem sx={{ fontSize: "1vw", padding: "0.5vw" }} value="1y">Último año</MenuItem>
                                </Select>
                              </Box>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </Grid>
                  </Stack>
                </Grid>
              </Grid>
            </Paper>
            <Paper
              elevation={3}
              sx={{ p: 2, borderRadius: 4, width: "100%", overflowX: "auto" }}
              className="paperReportes"
            >
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                  value={activeTabReportes}
                  onChange={handleTabReportesChange}
                  aria-label="tabs reportes"
                  textColor="primary"
                  indicatorColor="primary"
                >
                  <Tab
                    label={
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <span>Entregas dias posteriores</span>
                        <Chip
                          label={filtrarSolicitudes(solicitudesPosteriores, false).length}
                          size="small"
                          sx={{
                            backgroundColor: "#b33939",
                            color: "white",
                            fontWeight: "bold",
                            height: "20px",
                            fontSize: "0.75rem",
                            cursor: "pointer",
                            "& .MuiChip-label": {
                              padding: "0 6px"
                            }
                          }}
                        />
                      </Box>
                    }
                    id="tab-0"
                    aria-controls="tabpanel-0"
                    sx={{
                      color: "black",
                      backgroundColor: "#f0f0f0",
                      borderRadius: "8px",
                      marginRight: "8px",
                      cursor: "pointer",
                      "&:hover": {
                        backgroundColor: "#d9eaf7",
                        color: "#006787",
                      },
                      "&.Mui-selected": {
                        backgroundColor: "#006787",
                        color: "white",
                      },
                    }}
                  />
                  <Tab
                    label={
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <span>Entregas del dia de HOY</span>
                        <Chip
                          label={filtrarSolicitudes(solicitudesHoy, false).length}
                          size="small"
                          sx={{
                            backgroundColor: "#b33939",
                            color: "white",
                            fontWeight: "bold",
                            height: "20px",
                            fontSize: "0.75rem",
                            cursor: "pointer",
                            "& .MuiChip-label": {
                              padding: "0 6px"
                            }
                          }}
                        />
                      </Box>
                    }
                    id="tab-1"
                    aria-controls="tabpanel-1"
                    sx={{
                      color: "black",
                      backgroundColor: "#f0f0f0",
                      borderRadius: "8px",
                      marginRight: "8px",
                      cursor: "pointer",
                      "&:hover": {
                        backgroundColor: "#d9eaf7",
                        color: "#006787",
                      },
                      "&.Mui-selected": {
                        backgroundColor: "#014e65",
                        color: "white",
                      },
                    }}
                  />
                  <Tab
                    label={
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <span>Por entregar</span>
                        <Chip
                          label={filtrarSolicitudes(solicitudesAEntregar, false).length}
                          size="small"
                          sx={{
                            backgroundColor: "#b33939",
                            color: "white",
                            fontWeight: "bold",
                            height: "20px",
                            fontSize: "0.75rem",
                            cursor: "pointer",
                            "& .MuiChip-label": {
                              padding: "0 6px"
                            }
                          }}
                        />
                      </Box>
                    }
                    id="tab-2"
                    aria-controls="tabpanel-2"
                    sx={{
                      color: "black",
                      backgroundColor: "#f0f0f0",
                      borderRadius: "8px",
                      marginRight: "8px",
                      cursor: "pointer",
                      "&:hover": {
                        backgroundColor: "#d9eaf7",
                        color: "#006787",
                      },
                      "&.Mui-selected": {
                        backgroundColor: "#014e65",
                        color: "white",
                      },
                    }}
                  />
                  <Tab
                    label={
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <span>Entregados</span>
                        <Chip
                          label={filtroTexto.trim() ? filtrarSolicitudes(solicitudesEntregadas, true).length : 0}
                          size="small"
                          sx={{
                            backgroundColor: "#b33939",
                            color: "white",
                            fontWeight: "bold",
                            height: "20px",
                            fontSize: "0.75rem",
                            cursor: "pointer",
                            "& .MuiChip-label": {
                              padding: "0 6px"
                            }
                          }}
                        />
                      </Box>
                    }
                    id="tab-3"
                    aria-controls="tabpanel-3"
                    sx={{
                      color: "black",
                      backgroundColor: "#f0f0f0",
                      borderRadius: "8px",
                      marginRight: "8px",
                      cursor: "pointer",
                      "&:hover": {
                        backgroundColor: "#d9eaf7",
                        color: "#006787",
                      },
                      "&.Mui-selected": {
                        backgroundColor: "#014e65",
                        color: "white",
                      },
                    }}
                  />
                </Tabs>
              </Box>
              <TabPanel value={activeTabReportes} index={0}>
                {renderTablaSolicitudes(filtrarSolicitudes(solicitudesPosteriores, false), false)}
              </TabPanel>
              <TabPanel value={activeTabReportes} index={1}>
                {renderTablaSolicitudes(filtrarSolicitudes(solicitudesHoy, false), false)}
              </TabPanel>
              <TabPanel value={activeTabReportes} index={2}>
                {renderTablaSolicitudes(filtrarSolicitudes(solicitudesAEntregar, false), false)}
              </TabPanel>
              <TabPanel value={activeTabReportes} index={3}>
                {filtroTexto.trim() ? (
                  renderTablaSolicitudes(filtrarSolicitudes(solicitudesEntregadas, true), true)
                ) : (
                  <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", py: 4, backgroundColor: "#fff" }}>
                    <Typography sx={{ color: "#666", fontWeight: "bold" }}>
                      Realice una búsqueda por código de solicitud o nombre de paciente para mostrar las entregadas.
                    </Typography>
                  </Box>
                )}
              </TabPanel>
            </Paper>
          </Stack>
        </Box>

      </Content>
    </Layout>
  );
};
export default ReporteResultados;
